import { render, staticRenderFns } from "./FilterServicesByGroup.vue?vue&type=template&id=1bf38106&"
import script from "./FilterServicesByGroup.vue?vue&type=script&lang=ts&"
export * from "./FilterServicesByGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports